import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import StyledColoredTag from '../../app/components/styledComponents/StyledColoredTag';
import StyledText from '../../app/components/styledComponents/StyledText';
import BaseEditIcon from '../../app/components/svgIcons/BaseEditIcon';
import NewTrashIcon from '../../app/components/svgIcons/NewTrashIcon';
import { useLocation, useNavigate } from 'react-router-dom';
import StyledCheckbox from '../../app/components/checkbox/StyledCheckbox';
import { getImageUrl, productDefaultImage } from './assets/productsUtil';
import { OverlayTrigger } from 'react-bootstrap';
import { StyledTooltip } from '../../app/components/styledComponents/StyledTooltip';
import QuickAddIcon from '../../app/components/svgIcons/QuickAddIcon';
import { selectBasicInformation } from '../auth/authSlice';
import { useSelector } from 'react-redux';
import EyeIcon from '../orders/assets/images/eye';
import ProductDetail from './ProductDetail';
import { Offcanvas } from 'react-bootstrap';
import TagSelectorPopup from './TagSelectorPopup';
import StyledLoading from '../../app/components/loading/StyledLoading';
import moment from 'moment';
import AddIcon from '../../app/components/svgIcons/AddIcon';
import {
  useAddProductToCatalogueMutation,
  useDownVoteProductMutation,
  useRemoveProductFromCatalogueMutation,
  useUpdateProductStatusMutation,
  useUpdateProductStockStatusMutation,
  useUpVoteProductMutation,
} from './productsApiSlice';
import { toast } from 'react-toastify';
import useAuth from '../../hooks/useAuth';
import ConfirmationModal from '../../app/components/popups/ConfirmationModal';
import DeleteConfirmation from '../../app/components/popups/DeleteConfirmation';
import {
  calculateServiceFee,
  getPrices,
  isAuthorized,
} from '../../utils/helper';
import ThumbUpIcon from '../../app/components/svgIcons/ThumbUpIcon';
import StyledSwitch from '../../app/components/styledComponents/StyledSwitch';
import ViewEyeIcon from '../../app/components/svgIcons/ViewEyeIcon';
import ProductAddIcon from '../../app/components/svgIcons/ProductAddIcon';
import { HolidayPriceTag } from './ProductCard';
import { formatNumber } from '../../utils/helper';
import NewCloseIconn from '../../app/components/svgIcons/NewCloseIconn';

const Card = styled.div`
  border-radius: 8px;
  border: 0;
  box-shadow: 0 2px 4px 0 #00000014, 0 0 6px 0 #00000005;
  .card-body {
    padding: 32px;
    width: 70%;
  }
  font-family: ${({ theme }) => theme.fontFamily};

  img {
    border-radius: 6px;
  }

  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.md}px) {
      max-width: 100%;
      .card-body {
        padding: 16px;
      }
    }
  `}

  ${({ theme, selected }) => {
    if (selected) {
      return css`
        border: 2px solid ${theme.primary};
      `;
    }
  }}

  position: relative;

  :hover {
    box-shadow: 0px 0px 10px 10px rgba(0, 0, 0, 0.2);
  }

  transition: box-shadow 0.5s ease;
  cursor: pointer;
`;

const ProductImage = styled.div`
  overflow: hidden;
  height: 232px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.md}px) {
      width: 100%;
      height: 232px;
    }
  `}
`;

const StyledImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: ${({ src }) =>
    src == productDefaultImage ? 'contain' : 'cover'};
`;

const ProductTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: ${({ theme }) => theme.heading};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.md}px) {
      font-size: 18px;
      max-width: 150px;
    }
  `}
  a {
    color: inherit !important;
  }
`;

const CategoryName = styled.div`
  color: ${({ theme }) => theme.bodyMedium};
  font-weight: 400;
  font-size: 16px;
  line-height: 25.6px;
  margin-bottom: 8px;
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.md}px) {
      margin-bottom: 4px;
    }
  `}
`;

const Availability = styled(StyledColoredTag)`
  margin: 0;
  text-align: center;
`;

const Description = styled.div`
  color: ${({ theme }) => theme.heading};
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0;
  text-align: left;
  max-height: 52px;
  height: 52px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Number of lines to show */
  -webkit-box-orient: vertical;
`;

const Price = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 27px;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: -0.20000000298023224px;
  color: ${({ theme }) => theme.primary};
`;

const OffPrice = styled.div`
  text-decoration: line-through;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 18px;
  font-weight: 500;
  line-height: 29px;
  letter-spacing: -0.20000000298023224px;
  text-align: center;
  color: ${({ theme }) => theme.bodyLight};
`;

const TopTagDiv = styled.div`
  color: ${({ theme }) => theme.primary};
  background-color: ${({ theme }) => theme.white};
  clip-path: polygon(100% 0%, 100% 50%, 100% 100%, 0% 100%, 15% 50%, 0 0);
  padding: 6px 16px 6px 25px;
  margin-bottom: 5px;
  position: relative;
  z-index: 10;
`;

const TopTagDivRight = styled.div`
  color: ${({ theme }) => theme.primaryLight2};
  background-color: ${({ theme }) => theme.primary};
  padding: 5px 15px;
  bottom: 10px;
  left: 10px;
  border-radius: 16px;
  border: 1px solid white;
  position: relative;
  z-index: 10;
`;

const TopTagDivLeft = styled.div`
  bottom: 10px;
  right: 0px;
  position: relative;
  z-index: 100;
`;

const TopTagDivBg = styled.div`
  position: absolute;
  right: 0;
  top: 15px;
`;

const CardActionContainer = styled.div`
  background-color: ${({ theme }) => theme.primaryLight2};
  border-radius: 8px 8px 0 0;
`;

const ProgressContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);

  .CircularProgressbar {
    height: 80px;
  }
`;

const StyledThumbUpIconDiv = styled.div`
  background-color: ${({ theme }) => theme?.primary};

  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  width: 18px;
`;

const calculatePrice = (product, isCatalogue, isSelectProduct) => {
  const variationKey = isCatalogue ? 'variationDTOS' : 'floristVariationDTOS';
  const {
    price,
    originalPrice,
    oldPrice,
    isDiscountApplied,
    isHolidayPriceApplied,
    discountPrice,
    holidayPrice,
    
  } = getPrices(product, variationKey);

  if(!isCatalogue){
    return(
       <div className="d-flex flex-column">
              {(isDiscountApplied || isHolidayPriceApplied) && originalPrice ? (
                <div>
                  {isHolidayPriceApplied && holidayPrice ? (
                    <div className="d-flex flex-column">
                      <div className="d-flex flex-row align-items-center gap-2">
                        <Price>${formatNumber(holidayPrice)}</Price>
                        <OffPrice>${formatNumber(originalPrice)}</OffPrice>
                      </div>
                      <StyledText
                        color={'bodyMedium'}
                        $fontSize={'12px'}
                        $fontWeight={500}
                        className={`mb-0 margin-right`}
                      >
                        DP :
                        {discountPrice
                          ? ` $${formatNumber(discountPrice)}`
                          : oldPrice
                          ? ` $${formatNumber(oldPrice)}`
                          : ' NA'}
                      </StyledText>
                    </div>
                  ) : isDiscountApplied && discountPrice ? (
                    <div className="d-flex flex-column">
                      <div className="d-flex flex-row align-items-center gap-2">
                        <Price>${formatNumber(discountPrice)}</Price>
                        <OffPrice>${formatNumber(originalPrice)}</OffPrice>
                      </div>
                      <StyledText
                        color={'bodyMedium'}
                        $fontSize={'12px'}
                        $fontWeight={500}
                        className={`mb-0 margin-right`}
                      >
                        HP :{holidayPrice ? ` $${formatNumber(holidayPrice)}` : ' NA'}
                      </StyledText>
                    </div>
                  ) : (
                    <div className="d-flex flex-column">
                      <Price>${formatNumber(price)}</Price>
                      <div className="d-flex align-items-center gap-2">
                        <StyledText
                          color={'bodyMedium'}
                          $fontSize={'12px'}
                          $fontWeight={500}
                          className={`mb-0 margin-right`}
                        >
                          HP :
                          {holidayPrice ? ` $${formatNumber(holidayPrice)}` : ' NA'}
                        </StyledText>
                        <StyledText
                          color={'bodyMedium'}
                          $fontSize={'12px'}
                          $fontWeight={500}
                          className={`mb-0 margin-right`}
                        >
                          DP :{oldPrice ? ` $${formatNumber(oldPrice)}` : ' NA'}
                        </StyledText>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    position: 'relative',
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <Price>${formatNumber(price)}</Price>
                  </div>
      
                  <div className="d-flex align-items-center gap-2">
                    <StyledText
                      color={'bodyMedium'}
                      $fontSize={'12px'}
                      $fontWeight={500}
                      className={`mb-0 margin-right`}
                    >
                      HP :{holidayPrice ? ` $${formatNumber(holidayPrice)}` : ' NA'}
                    </StyledText>
                    <StyledText
                      color={'bodyMedium'}
                      $fontSize={'12px'}
                      $fontWeight={500}
                      className={`mb-0 margin-right`}
                    >
                      DP :{oldPrice ? ` $${formatNumber(oldPrice)}` : ' NA'}
                    </StyledText>
                  </div>
                </div>
              )}
      
              <StyledText
                color={'bodyLight'}
                $fontSize={'12px'}
                className={`mb-0 margin-right`}
              >
                <OverlayTrigger
                  overlay={
                    <StyledTooltip>
                      <span
                        style={{
                          fontSize: '12px',
                        }}
                      >
                        A service fee of $5.99 or 4%, whichever is higher, is applied
                        to each order. Florists can choose to pay this fee from the
                        received amount, or to apply it to the customer during
                        checkout (this means the customer pays it). This fee covers
                        the credit card processing and servicing of the order.
                      </span>
                    </StyledTooltip>
                  }
                >
                  <span style={{ cursor: 'pointer' }}>
                    (services fee: ${calculateServiceFee(oldPrice)})
                  </span>
                </OverlayTrigger>
              </StyledText>
            </div>
    )
  }

  return (
    <>
      {!isCatalogue && (oldPrice || discountPrice) ? (
        <>
          <div
            style={{
              position: !(isCatalogue && !isSelectProduct) && 'relative',
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <Price>
                $
                {isDiscountApplied
                  ? formatNumber(discountPrice)
                  : formatNumber(oldPrice)}
              </Price>
              <OffPrice>
                $
                {isDiscountApplied || isHolidayPriceApplied
                  ? formatNumber(originalPrice)
                  : formatNumber(price)}
              </OffPrice>
            </div>
            {isCatalogue && isSelectProduct ? (
              <StyledText
                color={'primary'}
                fontSize={'18px'}
                className={`mb-0 margin-right`}
              >
                (Suggested Price)
              </StyledText>
            ) : (
              !(isCatalogue && !isSelectProduct) && (
                <div
                  style={{
                    position: 'absolute',
                    width: 'max-content',
                    bottom: '-30px',
                    cursor: 'pointer',
                  }}
                >
                  {holidayPrice && (
                    <StyledText
                      color={'bodyLight'}
                      $fontSize={'11px'}
                      className={`mb-0 margin-right`}
                    >
                      (Holiday Price : ${formatNumber(holidayPrice)})
                    </StyledText>
                  )}
                  <StyledText
                    color={'bodyLight'}
                    $fontSize={'12px'}
                    className={`mb-0 margin-right`}
                  >
                    <OverlayTrigger
                      overlay={
                        <StyledTooltip>
                          <span
                            style={{
                              fontSize: '12px',
                            }}
                          >
                            A service fee of $5.99 or 4%, whichever is higher,
                            is applied to each order. Florists can choose to pay
                            this fee from the received amount, or to apply it to
                            the customer during checkout (this means the
                            customer pays it). This fee covers the credit card
                            processing and servicing of the order.
                          </span>
                        </StyledTooltip>
                      }
                    >
                      <span>
                        (services fee: ${calculateServiceFee(oldPrice)})
                      </span>
                    </OverlayTrigger>
                  </StyledText>
                </div>
              )
            )}
          </div>
        </>
      ) : (
        <div
          style={{ position: !(isCatalogue && !isSelectProduct) && 'relative' }}
        >
          {isHolidayPriceApplied ? (
            <Price>${formatNumber(originalPrice)}</Price>
          ) : (
            <Price>${formatNumber(price)}</Price>
          )}
          {isCatalogue && isSelectProduct ? (
            <StyledText
              color={'primary'}
              fontSize={'18px'}
              className={`mb-0 margin-right`}
            >
              (Suggested Price)
            </StyledText>
          ) : (
            !(isCatalogue && !isSelectProduct) && (
              <div
                style={{
                  position: 'absolute',
                  width: 'max-content',
                  bottom: '-30px',
                  cursor: 'pointer',
                }}
              >
                {holidayPrice && (
                  <StyledText
                    color={'bodyLight'}
                    $fontSize={'11px'}
                    className={`mb-0 margin-right`}
                  >
                    (Holiday Price : ${formatNumber(holidayPrice)})
                  </StyledText>
                )}
                <StyledText
                  color={'bodyLight'}
                  $fontSize={'12px'}
                  className={`mb-0 margin-right`}
                >
                  <OverlayTrigger
                    overlay={
                      <StyledTooltip>
                        <span
                          style={{
                            fontSize: '12px',
                          }}
                        >
                          A service fee of $5.99 or 4%, whichever is higher, is
                          applied to each order. Florists can choose to pay this
                          fee from the received amount, or to apply it to the
                          customer during checkout (this means the customer pays
                          it). This fee covers the credit card processing and
                          servicing of the order.
                        </span>
                      </StyledTooltip>
                    }
                  >
                    <span>(services fee: ${calculateServiceFee(price)})</span>
                  </OverlayTrigger>
                </StyledText>
              </div>
            )
          )}
        </div>
      )}
    </>
  );
};

const ProductListViewCard = ({
  product,
  refetch,
  deleteProduct,
  selectedProducts,
  handleProductSelection,
  onQuickAdd,
  isCatalogue,
  isProduct,
  isSelectProduct,
  isComingFromEditTemplate,
  onHandleButtonActionForTemplate,
  serProductEditId,
  onboarding,
  handleBulkEditTopTags,
  setUpdatingTag,
  catalogLoading,
  setShowDeleteConfirmation
}) => {
  const navigate = useNavigate();
  const basicInfo = useSelector(selectBasicInformation);
  const { theme, previewTheme } = useSelector((state) => state.theme);
  const [showRightPreview, setShowRightPreview] = useState(false);
  const [currentTime, setCurrentTime] = useState(moment());
  const [showAddProductToCatalogueDilog, setshowAddProductToCatalogueDilog] =
    useState(null);
  const [
    showRemoveItemFromCatalogueDilog,
    setshowRemoveItemFromCatalogueDilog,
  ] = useState(null);
  const [isRemovingFromCatalogue, setIsRemovingFromCatalogue] = useState(false);
  const [isAddingToCatalogue, setIsAddingToCatalogue] = useState(false);
  const [updateProductStatus] = useUpdateProductStatusMutation();
  const [updateProductStockStatus] = useUpdateProductStockStatusMutation();
  const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(false);
  const [updateStockStatusModal , setUpdateStockStatusModal] = useState(false);
  const [upVoteProduct] = useUpVoteProductMutation();
  const [downVoteProduct] = useDownVoteProductMutation();
  const [voteList, setVoteList] = useState([]);
  const [showAll, setShowAll] = useState(null);
  const [tempData, setTempData] = useState(null);
  const [clickedIcon, setClickedIcon] = useState(null);
  const [addProductToCatalogue] = useAddProductToCatalogueMutation();
  const [removeProductFromCatalogue] = useRemoveProductFromCatalogueMutation();
  const { user } = useAuth();
  const location = useLocation();
  const userPermissions = useSelector(
    (state) => state?.authorization?.userPermissions,
  );

  const [processText, setProcessText] = useState('Converting to WebP... ');

  useEffect(() => {
    const timeout1 = setTimeout(() => {
      setProcessText('Creating thumbnail....');
    }, 2000); // After 2 seconds

    const timeout2 = setTimeout(() => {
      setProcessText('Finalizing image...');
    }, 4000); // After another 2 seconds (total 4 seconds)

    // Clean up the timeouts on component unmount (optional)
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, []); 

  const has_permission_to_edit = isAuthorized(userPermissions, 'edit_product');
  const has_permission_to_delete = isAuthorized(
    userPermissions,
    'can_delete_product',
  );
  const has_permission_to_catalog = isAuthorized(
    userPermissions,
    'can_contribute_to_catalog',
  );
  const has_permission_to_remove_catalog = isAuthorized(
    userPermissions,
    'can_remove_from_catalog',
  );

  const loadTags = (tags) => {
    const aryTags = [];
    const filterData = tags.filter((t) => t.parentCategory === 5) || [];
    filterData.slice(0, 3)?.forEach((tag, index) => {
      aryTags.push(
        <TopTagDiv key={index + 'TopTagDiv'}>
          <StyledText
            color={'primary'}
            fontSize={'14px'}
            $fontWeight="600"
            className={`mb-0 margin-right`}
          >
            {tag?.name}
          </StyledText>
        </TopTagDiv>,
      );
    });
    if (aryTags.length > 0) {
      return <TopTagDivBg>{aryTags}</TopTagDivBg>;
    }
    return <></>;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, [10000]);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (tempData?.votes) {
      setVoteList(!tempData?.votes ? [] : tempData?.votes);
    } else if (product?.votes) {
      setVoteList(!product?.votes ? [] : product?.votes);
    } else {
      setVoteList([]);
    }
  }, [product, product?.votes, tempData]);

  const handleAddToCatalogue = () => {
    setIsAddingToCatalogue(true);
    addProductToCatalogue({ id: product?.id })
      .then((data) => {
        if (!data?.error) {
          toast.success('Product added to Catalogue Successfully');
          refetch();
        }
      })
      .catch((error) => {
        console.error('Error adding product to catalogue:', error);
      });
    setIsAddingToCatalogue(false);
    setshowAddProductToCatalogueDilog(null);
  };

  const handleRemoveItemFromCatalogue = () => {
    setIsRemovingFromCatalogue(true);
    removeProductFromCatalogue(product?.id)
      .then((data) => {
        if (!data?.error) {
          toast.success('Product Removed from Catalogue Successfully');
          refetch();
        }
      })
      .catch((error) => {
        console.error('Error adding Removing from Catalogue:', error);
      });
    refetch();
    setIsRemovingFromCatalogue(false);
    setshowRemoveItemFromCatalogueDilog(null);
  };

  const checkIsLiked = () => {
    if (tempData) {
      if (!tempData?.votes) {
        return false;
      } else {
        if (!Array.isArray(tempData?.votes)) {
          return false;
        }

        // Find the vote object where floristId matches user?.id

        const voteEntry = tempData.votes.find(
          (vote) => vote.floristId === user?.floristId,
        );

        // If a matching voteEntry is found, return its vote status, otherwise return false
        return voteEntry ? voteEntry.vote : false;
      }
    } else {
      if (!product?.votes) {
        return false;
      } else {
        if (!Array.isArray(product?.votes)) {
          return false;
        }

        // Find the vote object where floristId matches user?.id

        const voteEntry = product.votes.find(
          (vote) => vote.floristId === user?.floristId,
        );

        // If a matching voteEntry is found, return its vote status, otherwise return false
        return voteEntry ? voteEntry.vote : false;
      }
    }
  };

  const setTempProductData = (data) => {
    const productData = { ...product };
    const votes = [...(product?.votes || [])];
    const voteIndex = votes.findIndex((vote) => vote.id === data.id);

    if (data.vote === false) {
      if (voteIndex !== -1) {
        votes.splice(voteIndex, 1);
      }
    } else if (data.vote === true) {
      if (voteIndex === -1) {
        votes.push(data);
      }
    }
    productData.votes = votes;
    setTempData(productData);
  };

  const handleClick = () => {
    if (checkIsLiked()) {
      downVoteProduct(product?.id)
        .then((data) => {
          if (!data?.error) {
            toast.success('Removed Successfully');
            setTempProductData(data?.data?.objectData);
          }
        })
        .catch((error) => {
          console.error('Error downvoting product:', error);
        });
    } else {
      upVoteProduct(product?.id)
        .then((data) => {
          if (!data?.error) {
            toast.success('Product Upvoted Successfully');
            setTimeout(() => setClickedIcon(null), 500);
            setTempProductData(data?.data?.objectData);
          }
        })
        .catch((error) => {
          console.error('Error upvoting product:', error);
          setTimeout(() => setClickedIcon(null), 500);
        });
      setClickedIcon(product?.id); // set the clicked icon id
    }
  };

  const handleUpdateStatus = () => {
    setUpdatingTag(true);
    updateProductStatus({
      activate: !product?.activated,
      inventoryDTOS: [{ id: product?.id }],
    })
      .then((data) => {
        if (!data?.error) {
          toast.success('Product Status Updated Successfully');
          refetch();
        }
      })
      .catch((error) => {
        console.error('Error updating product status:', error);
      });
  };

    const handleUpdateStockStatus = () => {
      setUpdatingTag(true);
      updateProductStockStatus({
        stockStatus: !product?.stockStatus,
        inventoryDTOS: [{ id: product?.id }],
      })
        .then((data) => {
          if (!data?.error) {
            toast.success('Product Status Updated Successfully');
            refetch();
          }
        })
        .catch((error) => {
          console.error('Error updating product status:', error);
        });
    };

  // Show a maximum of 10 names or all names if showAll is true
  const displayedVotes =
    showAll === product?.id ? voteList : voteList?.slice(0, 10);

  return (
    <>
      <Card
        style={{
          border:
            !isCatalogue &&
            ((product?.holidayPriceApplied && product?.holidayPrice) ||
              (product?.discountPriceApplied && product?.discountPrice))
              ? `2px solid ${theme?.primary}`
              : 'none',
        }}
        className="card"
        selected={selectedProducts.includes(product?.id)}
      >
        <div
          className="position-absolute top-0 end-0 bottom-0 start-0"
          {...(!onboarding
            ? { onClick: () => setShowRightPreview(true) }
            : {
                onClick: () => {
                  if (product.catalogItem) return;
                  handleProductSelection(
                    product?.id,
                    !selectedProducts.includes(product?.id),
                  );
                },
              })}
        ></div>
        <CardActionContainer className="d-flex justify-content-between align-items-center px-2 py-1">
          <OverlayTrigger
            overlay={
              <StyledTooltip>
                {location.pathname === '/settings/products/catalog' &&
                isCatalogue &&
                user?.floristId === product?.contributedFloristId
                  ? 'This item is already contributed by you'
                  : 'This item is already added to your Products'}
              </StyledTooltip>
            }
            {...((!isCatalogue || !product?.catalogItem) &&
              !(
                location.pathname === '/settings/products/catalog' &&
                isCatalogue &&
                user?.floristId === product?.contributedFloristId
              ) && {
                show: false,
              })}
          >
            <span>
              <StyledCheckbox
                color
                disabled={
                  location.pathname === '/settings/products/catalog' &&
                  isCatalogue &&
                  user?.floristId === product?.contributedFloristId
                    ? true
                    : false || (isCatalogue && product?.catalogItem)
                }
                bgColor={'primary'}
                borderColor={'gray40'}
                value={selectedProducts.includes(product?.id)}
                onChange={(e) =>
                  handleProductSelection(product?.id, e.target.checked)
                }
                style={{
                  zIndex: 1,
                }}
              />
            </span>
          </OverlayTrigger>
          {!isSelectProduct && (
            <TagSelectorPopup
              product={product}
              isCatalogue={isCatalogue}
              handleBulkEditTopTags={handleBulkEditTopTags}
              refetch={refetch}
              style={{
                zIndex: 10,
              }}
            />
          )}
        </CardActionContainer>

        <div className="d-flex align-items-md-center flex-column flex-md-row">
          <div
            className="position-relative"
            style={{ width: '30%', minWidth: '300px' }}
          >
            <ProductImage className="card-img-top">
              <StyledImage
                loading="lazy"
                src={getImageUrl(product, isCatalogue, currentTime)}
                alt={product?.itemName}
              />
              {(product?.inventoryTagDTOS ||
                product?.floristInventoryTagDTOS) &&
                isProduct && (
                  <>
                    {loadTags(
                      product?.inventoryTagDTOS ||
                        product?.floristInventoryTagDTOS,
                    )}
                  </>
                )}
            </ProductImage>
            {product.uploading && (
              <ProgressContainer>
                {product?.progress == undefined || product.progress == 100 ? (
                  <div className="d-flex flex-row justify-content-center align-items-center">
                    <StyledLoading
                      color={'#fff'}
                      style={{
                        height: '1rem',
                        width: '1rem',
                        fontSize: '12px',
                      }}
                    />
                    <StyledText
                      $fontSize="14px"
                      $fontWeight="500"
                      color="white"
                      className="mx-2 mb-0"
                    >
                      {processText}
                    </StyledText>
                  </div>
                ) : (
                  <>
                    <StyledLoading style={{ height: '4rem', width: '4rem' }} />
                    <div className="position-absolute">
                      <StyledText color="white">
                        {product.progress !== 100 && `${product.progress}%`}
                      </StyledText>
                    </div>
                  </>
                )}
              </ProgressContainer>
            )}

            {isProduct && product?.contributed && (
              <TopTagDivRight style={{ position: 'absolute' }}>
                <StyledText
                  color={'primaryLight2'}
                  fontSize={'14px'}
                  $fontWeight="600"
                  className={`mb-0 margin-right`}
                  style={{ cursor: 'default' }}
                >
                  Added to Catalog
                </StyledText>
              </TopTagDivRight>
            )}
            {isProduct && (
              <TopTagDivLeft
                style={{
                  position: 'absolute',
                  bottom: '40px',
                }}
                onClick={() => setShowRightPreview(false)}
              >
                <StyledSwitch
                  onClick={() => setShowRightPreview(false)}
                  enableText="Active"
                  height="25px"
                  circleHeight={17}
                  circleWidth={17}
                  disableText="Inactive"
                  width="87px"
                  checked={product?.activated}
                  onChange={() => setOpenUpdateStatusModal(true)}
                />
              </TopTagDivLeft>
            )}
            {isProduct &&
              (
                <TopTagDivLeft
                  style={{ position: 'absolute' }}
                  onClick={() => setShowRightPreview(false)}
                >
                  <StyledSwitch
                    onClick={() => setShowRightPreview(false)}
                    enableText="In Stock"
                    height="25px"
                    circleHeight={17}
                    circleWidth={17}
                    disableText="out of Stock"
                    width="112px"
                    checked={product?.stockStatus}
                    onChange={() => setUpdateStockStatusModal(true)}
                  />
                </TopTagDivLeft>
              )}
          </div>
          <div className="card-body">
            {isCatalogue && (
              <div
                style={{
                  zIndex: 1,
                  position: 'relative',
                  cursor: 'pointer',
                  maxWidth: 'fit-content',
                }}
                className="d-flex flex-row justify-content-start align-items-center p-0"
              >
                <OverlayTrigger
                  overlay={<StyledTooltip>Total Views</StyledTooltip>}
                >
                  <div
                    style={{ cursor: 'pointer' }}
                    className="d-flex flex-row align-items-center justify-content-center"
                  >
                    <ViewEyeIcon size={18} color={theme?.primary} />
                    <StyledText
                      className="mx-1"
                      style={{ marginBottom: 0 }}
                      color={'#333333'}
                      $fontSize={'12px'}
                    >
                      {product?.customerViews ?? 0}
                    </StyledText>
                  </div>
                </OverlayTrigger>
                <OverlayTrigger
                  overlay={<StyledTooltip>Total Adds</StyledTooltip>}
                >
                  <div
                    style={{ cursor: 'pointer' }}
                    className="mx-1 d-flex flex-row align-items-center justify-content-center"
                  >
                    <ProductAddIcon
                      size={25}
                      className="m-0"
                      color={theme?.primary}
                    />
                    <StyledText
                      $fontSize={'12px'}
                      style={{ marginBottom: 0 }}
                      color={'#333333'}
                    >
                      {product?.addedByFlorists ?? 0}
                    </StyledText>
                  </div>
                </OverlayTrigger>
                <div>
                  <OverlayTrigger
                    overlay={
                      <StyledTooltip>
                        {voteList && voteList.length > 0 ? (
                          <div>
                            {displayedVotes.map((vote, index) => (
                              <div
                                key={index}
                                style={{
                                  textAlign: 'left',
                                }}
                              >
                                {vote?.companyName}
                              </div>
                            ))}
                            {voteList.length > 10 && (
                              <button
                                style={{
                                  marginTop: '10px',
                                  cursor: 'pointer',
                                }}
                                onClick={() =>
                                  setShowAll(
                                    showAll === product?.id
                                      ? null
                                      : product?.id,
                                  )
                                }
                              >
                                {showAll === product?.id
                                  ? 'Show Less'
                                  : 'See More'}
                              </button>
                            )}
                          </div>
                        ) : (
                          <div>No votes available</div>
                        )}
                      </StyledTooltip>
                    }
                  >
                    <div
                      style={{ marginLeft: '5px' }}
                      className="d-flex align-items-center"
                    >
                      <StyledThumbUpIconDiv className="mx-1">
                        {' '}
                        <ThumbUpIcon
                          transperant={true}
                          size={10}
                          fillColor="white"
                          style={{ position: 'relative', top: '-1px' }}
                        />
                      </StyledThumbUpIconDiv>
                      <span
                        style={{
                          cursor: 'pointer',
                          fontSize: '12px',
                          // marginLeft: '5px',
                        }}
                      >
                        {tempData
                          ? tempData?.votes?.length
                          : voteList?.length || 0}
                      </span>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            )}
            <div className="d-flex align-items-start justify-content-between gap-3">
              <div style={{ flex: 2 }} className="overflow-hidden">
                <ProductTitle className="card-title">
                  {isComingFromEditTemplate && (
                    <div style={{ cursor: 'pointer' }}>
                      {product?.itemName || ''}
                    </div>
                  )}
                  {!isComingFromEditTemplate && (
                    <div className="cursor-pointer">
                      {product?.itemName || ''}
                    </div>
                  )}
                </ProductTitle>
                {isCatalogue ? (
                  product?.productRecognition ? (
                    <p
                      style={{
                        fontStyle: 'italic',
                        fontSize: '14px',
                        color: '#9E9C9C',
                      }}
                    >
                      Designed by {product?.productRecognition || ''}
                    </p>
                  ) : (
                    <p
                      style={{
                        fontStyle: 'italic',
                        fontSize: '14px',
                        color: '#9E9C9C',
                      }}
                    >
                      Designed by BoostFloral
                    </p>
                  )
                ) : (
                  !isCatalogue &&
                  (product?.catalogItem ? (
                    product?.productRecognition ? (
                      <p
                        style={{
                          fontStyle: 'italic',
                          fontSize: '14px',
                          color: '#9E9C9C',
                        }}
                      >
                        Designed by {product?.productRecognition || ''}
                      </p>
                    ) : (
                      <p
                        style={{
                          fontStyle: 'italic',
                          fontSize: '14px',
                          color: '#9E9C9C',
                        }}
                      >
                        Designed by BoostFloral
                      </p>
                    )
                  ) : (
                    <CategoryName>
                      {/* {product?.categoryDTO?.name || ''} */}
                    </CategoryName>
                  ))
                )}
              </div>

              {isProduct && (
                <div
                  className="d-flex flex-column gap-2 mb-2"
                  style={{ flex: 1 }}
                >
                  <Availability
                    variant={product.stockStatus ? 'successTag' : 'dangerTag'}
                  >
                    {product.stockStatus ? 'In stock' : 'Out of Stock'}
                  </Availability>
                </div>
              )}
              {/* {isCatalogue && product?.catalogItem && (
                <div className="d-flex flex-column ">
                  <Availability variant={'primary'}>Added</Availability>
                </div>
              )} */}
            </div>

            <Description
              dangerouslySetInnerHTML={{
                __html: product?.description || '',
              }}
            />
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex gap-2 align-items-center">
                {calculatePrice(product, isCatalogue, isSelectProduct)}
              </div>

              <div className="d-flex align-items-center gap-2 align-self-end">
                {isCatalogue &&
                  !onboarding &&
                  (isSelectProduct ? (
                    user?.floristId === product?.contributedFloristId ? (
                      <>
                        <StyledText
                          className={`mb-0 cursor-pointer`}
                          onClick={() => handleClick()}
                          style={{
                            zIndex: 1,
                            transition: 'all 0.3s ease-in-out',
                          }}
                        >
                          <OverlayTrigger
                            overlay={
                              <StyledTooltip>
                                {checkIsLiked() ? 'Remove Vote' : 'Upvote'}
                              </StyledTooltip>
                            }
                          >
                            <span className={`ms-2 ms-md-3 cursor-pointer`}>
                              <ThumbUpIcon
                                style={{
                                  transition: ' transform 0.3s ease-in-out',
                                }}
                                className={
                                  clickedIcon === product?.id ? 'clicked' : ''
                                }
                                transperant={
                                  clickedIcon !== product?.id && !checkIsLiked()
                                }
                                cuffColor={
                                  previewTheme?.primary ??
                                  theme?.primary ??
                                  '#004CFF'
                                }
                              />
                              <style jsx>
                                {`
                                  .clicked {
                                    transform: scale(1.2) rotate(-10deg);
                                  }
                                `}
                              </style>
                            </span>
                          </OverlayTrigger>
                        </StyledText>
                        <StyledText
                          color={'icon'}
                          className={`mb-0 ${
                            has_permission_to_remove_catalog
                              ? 'cursor-pointer'
                              : 'cursor-not-allowed opacity-50'
                          } margin-right`}
                          style={{
                            zIndex: 1,
                          }}
                          onClick={() => {
                            has_permission_to_remove_catalog &&
                              setshowRemoveItemFromCatalogueDilog(product);
                          }}
                        >
                          <OverlayTrigger
                            overlay={
                              <StyledTooltip>
                                {has_permission_to_remove_catalog
                                  ? 'Remove Item from Catalog'
                                  : 'You do not have permission to remove product from catalog'}
                              </StyledTooltip>
                            }
                          >
                            <span className={`ms-2 ms-md-3`}>
                              <NewTrashIcon />
                            </span>
                          </OverlayTrigger>
                        </StyledText>
                      </>
                    ) : (
                      <>
                        <StyledText
                          className={`mb-0 cursor-pointer`}
                          onClick={() => handleClick()}
                          style={{
                            zIndex: 1,
                            transition: 'all 0.3s ease-in-out',
                          }}
                        >
                          <OverlayTrigger
                            overlay={
                              <StyledTooltip>
                                {checkIsLiked() ? 'Remove Vote' : 'Upvote'}
                              </StyledTooltip>
                            }
                          >
                            <span className={`ms-2 ms-md-3 cursor-pointer`}>
                              <ThumbUpIcon
                                style={{
                                  transition: ' transform 0.3s ease-in-out',
                                }}
                                className={
                                  clickedIcon === product?.id ? 'clicked' : ''
                                }
                                transperant={
                                  clickedIcon !== product?.id && !checkIsLiked()
                                }
                                cuffColor={
                                  previewTheme?.primary ??
                                  theme?.primary ??
                                  '#004CFF'
                                }
                              />
                              <style jsx>
                                {`
                                  .clicked {
                                    transform: scale(1.2) rotate(-10deg);
                                  }
                                `}
                              </style>
                            </span>
                          </OverlayTrigger>
                        </StyledText>

                        {product.catalogItem ? (
                          <Availability variant={'primaryGreen'}>
                            Added
                          </Availability>
                        ) : (
                          <StyledText
                            color={'icon'}
                            className={`mb-0 margin-right `}
                            style={{
                              zIndex: 1,
                            }}
                            onClick={() => {
                              if (product?.catalogItem) return;
                              onQuickAdd({ id: product?.id });
                            }}
                          >
                            {catalogLoading[product?.id] ? (
                              <StyledLoading
                                minHeight={'2vh'}
                                style={{
                                  height: '1.5rem',
                                  width: '1.5rem',
                                  marginLeft: '5px',
                                }}
                              />
                            ) : (
                              <OverlayTrigger
                                overlay={
                                  <StyledTooltip>
                                    {product.catalogItem
                                      ? 'Product has already been added to the catalog'
                                      : 'Quick Add to Products'}
                                  </StyledTooltip>
                                }
                              >
                                <span
                                  className={`ms-2 ms-md-3 ${
                                    product?.catalogItem
                                      ? 'cursor-not-allowed opacity-50'
                                      : 'cursor-pointer'
                                  }`}
                                >
                                  <QuickAddIcon />
                                </span>
                              </OverlayTrigger>
                            )}
                          </StyledText>
                        )}
                      </>
                    )
                  ) : (
                    <>
                      <StyledText
                        color={'icon'}
                        className="mb-0 cursor-pointer margin-right"
                        onClick={() => navigate(`${product.id}`)}
                        style={{
                          zIndex: 1,
                        }}
                        title="Edit Product"
                      >
                        <BaseEditIcon />
                      </StyledText>

                      <StyledText
                        color={'error'}
                        className="mb-0 cursor-pointer"
                        onClick={() => {
                          if (isProduct && product?.catalogItem) {
                            setShowDeleteConfirmation(3);
                            deleteProduct(product.id);
                          } else {
                            setShowDeleteConfirmation(1);
                            deleteProduct(product.id);
                          }
                        }}
                        style={{
                          zIndex: 1,
                        }}
                        title={
                          isProduct && product?.catalogItem
                            ? 'Remove catalog product from your products'
                            : 'Delete Product'
                        }
                      >
                        {isProduct && product?.catalogItem ? (
                          <NewCloseIconn color={'#d95454'} size={24} />
                        ) : (
                          <NewTrashIcon />
                        )}
                      </StyledText>
                    </>
                  ))}

                {!isCatalogue && (
                  <>
                    {!product?.catalogItem && !product?.contributed && (
                      <StyledText
                        color={'icon'}
                        className={`mb-0 ${
                          has_permission_to_catalog
                            ? 'cursor-pointer'
                            : 'cursor-not-allowed opacity-50'
                        } margin-right`}
                        style={{
                          zIndex: 1,
                        }}
                        title={
                          has_permission_to_catalog
                            ? 'Add Product to Catalog'
                            : 'You do not have permission to add product to catalog'
                        }
                        onClick={() =>
                          has_permission_to_catalog &&
                          setshowAddProductToCatalogueDilog(product)
                        }
                      >
                        <AddIcon />
                      </StyledText>
                    )}
                    <StyledText
                      as="a"
                      color={'icon'}
                      className="mb-0 cursor-pointer margin-right"
                      href={
                        basicInfo?.subdomainUrl
                          ? `${basicInfo?.subdomainUrl}/products/${product.slug}`
                          : '#'
                      }
                      target="_blank"
                      style={{
                        zIndex: 1,
                      }}
                      title="View Product on Website"
                    >
                      <EyeIcon />
                    </StyledText>

                    <StyledText
                      color={'icon'}
                      className={`mb-0 ${
                        has_permission_to_edit
                          ? 'cursor-pointer'
                          : 'cursor-not-allowed opacity-50'
                      } margin-right`}
                      onClick={() => {
                        if (has_permission_to_edit) {
                          if (isComingFromEditTemplate) {
                            onHandleButtonActionForTemplate('editproduct');
                            serProductEditId(product.id);
                            return;
                          }
                          navigate(`${product.id}`);
                        }
                      }}
                      style={{
                        zIndex: 1,
                      }}
                      title={
                        has_permission_to_edit
                          ? 'Edit Product'
                          : 'You do not have permission to edit product'
                      }
                    >
                      <BaseEditIcon />
                    </StyledText>

                    <StyledText
                      color={'error'}
                      className={`mb-0 ${
                        has_permission_to_delete
                          ? 'cursor-pointer'
                          : 'cursor-not-allowed opacity-50'
                      }`}
                      onClick={() => {
                        if (!has_permission_to_delete) {
                          return;
                        } else {
                          if (isProduct && product?.catalogItem) {
                            setShowDeleteConfirmation(3);
                            deleteProduct(product.id);
                          } else {
                            setShowDeleteConfirmation(1);
                            deleteProduct(product.id);
                          }
                        }
                      }}
                      style={{
                        zIndex: 1,
                      }}
                      title={
                        has_permission_to_delete
                          ? isProduct && product?.catalogItem
                            ? 'Remove catalog product from your products'
                            : 'Delete Product'
                          : `You do not have permission to ${
                              product?.catalogItem ? 'remove' : 'delete'
                            }  product`
                      }
                    >
                      {isProduct && product?.catalogItem ? (
                        <NewCloseIconn color={'#d95454'} size={24} />
                      ) : (
                        <NewTrashIcon />
                      )}
                    </StyledText>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {!isCatalogue && (
          <>
            {product?.holidayPriceApplied && product?.holidayPrice ? (
              <HolidayPriceTag>
                Holiday Price Applied :{' '}
                {product?.holidayPrice
                  ? `$${product?.holidayPrice.toFixed(2)}`
                  : '-'}
              </HolidayPriceTag>
            ) : product?.discountPriceApplied && product?.discountPrice ? (
              <HolidayPriceTag>
                Holiday Price Applied :{' '}
                {product?.discountPrice
                  ? `$${product?.discountPrice.toFixed(2)}`
                  : '-'}
              </HolidayPriceTag>
            ) : null}
          </>
        )}
      </Card>

      <ConfirmationModal
        show={!showAddProductToCatalogueDilog ? false : true}
        isLoading={isAddingToCatalogue}
        heading={'Add this Product to the Catalog'}
        bodyText={`This allows other Florists to find this Product in the Catalog, add it to their Product List, and offer it for sale on their website.  You can remove it from the Catalog at any time.`}
        bodyText2={`By submitting this product and its associated images 
  into the public directory, the Florist confirms that they 
  own all rights to the content and images and hereby 
  grant permission for their use and sale by other Florists.`}
        ButtonText={'Add'}
        onClick={() => {
          !isAddingToCatalogue && handleAddToCatalogue(product);
        }}
        onCancel={() => {
          setshowAddProductToCatalogueDilog(null);
          setIsAddingToCatalogue(false);
        }}
      />

      <DeleteConfirmation
        show={!showRemoveItemFromCatalogueDilog ? false : true}
        isLoading={isRemovingFromCatalogue}
        bodyText={'This will remove this Product from the Catalog.'}
        onDelete={handleRemoveItemFromCatalogue}
        onCancel={() => {
          setshowRemoveItemFromCatalogueDilog(null);
        }}
      />

      <ConfirmationModal
        show={openUpdateStatusModal}
        bodyText={`${
          product?.activated
            ? 'This will remove the Product from all website pages.'
            : 'This will activate the Product and will be seen on all website pages.'
        }`}
        ButtonText={product?.activated ? 'Deactivate' : 'Activate'}
        onClick={() => {
          handleUpdateStatus();
          setOpenUpdateStatusModal(false);
        }}
        onCancel={() => {
          setOpenUpdateStatusModal(false);
        }}
      />

      <ConfirmationModal
        show={updateStockStatusModal}
        bodyText={`${
          product?.stockStatus
            ? 'If you mark this product as out of stock, all the variation of this product will be marked as out of stock.'
            : 'This product will now be available for purchase.'
        }`}
        ButtonText={'Confirm'}
        onClick={() => {
          handleUpdateStockStatus();
          setUpdateStockStatusModal(false);
        }}
        onCancel={() => {
          setUpdateStockStatusModal(false);
        }}
      />

      <Offcanvas
        show={showRightPreview}
        onHide={() => setShowRightPreview(false)}
        placement={'end'}
        style={{ width: '50%' }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Product Detail</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ProductDetail
            productId={product?.id}
            isCatalogue={isCatalogue}
            isProduct={isProduct}
            isSelectProduct={isSelectProduct}
            addToProductsHandler={() => {
              if (product?.catalogItem) return;
              onQuickAdd({ id: product?.id });
            }}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ProductListViewCard;
